module.exports = __webpack_public_path__ + "2c2b926167e61aa7dacd9af1690d6727.jpg";